import CartAddButton from "./Elements/CartAddButton";
import VariantRadios from "./Elements/VariantSelectors/VariantRadios";
import VariantSelects from "./Elements/VariantSelectors/VariantSelects";
import QuantityInput from "./Elements/QuantityInput/QuantityInput";
import QuantityInputSelect from "./Elements/QuantityInput/QuantityInputSelect";
import MenuDrawer from "./Elements/MenuDrawer";
import HeaderDrawer from "./Elements/HeaderDrawer";

import ModalDialog from "./Elements/ModalDialog";
import ModalOpener from "./Elements/ModalOpener";
import DeferredMedia from "./Elements/DeferredMedia";
import SliderComponent from "./Elements/SliderComponent";
import CollectionCard from "./Elements/CollectionCard";
import CollectionCardList from "./Elements/CollectionCardList";
import ProductPlaylist from "./Elements/ProductPlaylist";
import AudioPlayer from "./Elements/AudioPlayer";
import ProductModal from "./Elements/ProductModal";
import StickyHeader from "./Elements/StickyHeader";
import LocalizationForm from "./Elements/LocalizationForm";

export default function registerElements() {
    customElements.define('cart-add-button', CartAddButton);

    customElements.define('variant-selects', VariantSelects);
    customElements.define('variant-radios', VariantRadios);

    customElements.define('quantity-input', QuantityInput);
    customElements.define('quantity-input-select', QuantityInputSelect);

    customElements.define('menu-drawer', MenuDrawer);
    customElements.define('header-drawer', HeaderDrawer);

    customElements.define('modal-dialog', ModalDialog);
    customElements.define('modal-opener', ModalOpener);
    customElements.define('deferred-media', DeferredMedia);
    customElements.define('slider-component', SliderComponent);
    customElements.define('collection-card', CollectionCard);
    customElements.define('collection-card-list', CollectionCardList);
    customElements.define('product-playlist', ProductPlaylist);
    customElements.define('audio-player', AudioPlayer);
    customElements.define('product-modal', ProductModal);
    customElements.define('sticky-header', StickyHeader);
    customElements.define('localization-form', LocalizationForm);
};